import { Container, Message } from './elements'
import usePostTransaction from '../../../../../Utilities/API/enterpriseTransactions/postTransaction'
import AddTransactionForm from './AddTransactionForm'
import { Transaction } from './types'

const ManualAddTransaction = () => {
  const [status, message, postTransaction] = usePostTransaction()

  const isLoading = status === 'LOADING'
  const isError = status === 'ERROR'

  const handleSubmit = (transaction: Transaction) => {
    postTransaction(transaction)
  }

  return (
    <Container>
      <Message error={isError}>{message.message}</Message>
      <AddTransactionForm handleSubmit={handleSubmit} isLoading={isLoading} />
    </Container>
  )
}

export default ManualAddTransaction
